<template>
    <div>
        <button @click="showCateglist" v-if="!showing" class="menu-category-button">Меню V</button>
        <ul id="menu-categories" v-if="showing" class="menu-categories">
            <li v-if="shops.length > 1"> <h3> {{shop.name}} </h3> </li>
            <li v-if="shops.length > 1"><a href="#" class="menu-category-link" @click="$emit('back')">&lt; Выбрать другой ресторан</a></li>
            <li><a v-for="cat in categlist" :key="cat" @click.prevent="$emit('scrollto', cat)" :href=" '#'+cat " class="menu-category-link">{{ cat }}</a></li>
        </ul>
    </div>
</template>

<script>
export default {
    props:['categlist', 'shops', 'shop'],
    data() {
        return {
            showing: false
        }
    },
    methods:{
        showCateglist: function(){
            this.showing = true
        },
        scrollHandler(){
            if (this.showing) this.showing = false
        }
    },
    mounted(){
        this.showing = window.innerWidth > 500
        if (!this.showing) {
            window.addEventListener('scroll', this.scrollHandler)
        }
    },
    destroyed(){
        window.removeEventListener('scroll', this.scrollHandler)
    }
}
</script>